import { W as WuiListItemHeader$1, d as defineCustomElement$1 } from './p-DLWyhg_S.js';

const WuiListItemHeader = WuiListItemHeader$1;
const defineCustomElement = defineCustomElement$1;

export { WuiListItemHeader, defineCustomElement };
